import { generateClassName } from "../../utils/generateClassName";
import React, { Suspense, useEffect, useState } from "react";
import RoleBasedRoute from "./components/RoleBasedRoute";
import { Redirect, Switch } from "react-router-dom";
import { JssProvider } from "react-jss";
import Roles from "../../../../src/app/enums/RoleEnum";

import { MaintenanceSettingsPage } from '../maintenance-settings/index';
import {
	ProjectsForm,
	ProjectsListing,
	PromptsForm,
	PromptsListing,
	FailedAudioListing,
	VoiceModelsForm,
	VoiceModelsListing,
	UsersListing,
	UsersForm,
	ApikeysListing,
	ApikeysForm,
	SettingsManagerForm,
	UsersCreateForm,
	CostsForm,
	ProvidersListing,
	ProvidersForm,
	PresetsListing,
	PresetsForm
} from "./pages";

export default function RoleBasedGuard(props) {
	const [width, setWidth] = useState(window.innerWidth);

	const resizeEvent = () => {
		if (window.innerWidth !== width) {
			setWidth(window.innerWidth);
		}
	};

	useEffect(() => {
		window.addEventListener("resize", resizeEvent);

		return () => window.removeEventListener("resize", resizeEvent);
	});

	return (
		<Suspense>
			<Switch>
				<JssProvider generateClassName={generateClassName}>
					<Redirect exact from="/dashboard" to="/dashboard/projects" />
					<RoleBasedRoute
						permissionLevel={[Roles.ADMIN]}
						exact
						path="/dashboard/users"
						component={() => <UsersListing width={width} />}
					/>
					<RoleBasedRoute
						permissionLevel={[Roles.ADMIN]}
						path="/dashboard/users/:id/edit"
						component={UsersForm}
					/>
					<RoleBasedRoute
						permissionLevel={[Roles.ADMIN]}
						path="/dashboard/users/new"
						component={UsersCreateForm}
					/>
					<RoleBasedRoute
						permissionLevel={[Roles.ADMIN]}
						exact
						path="/dashboard/apikeys"
						component={() => <ApikeysListing width={width} />}
					/>
					<RoleBasedRoute
						permissionLevel={[Roles.ADMIN]}
						path="/dashboard/apikeys/:id/edit"
						component={ApikeysForm}
					/>
					<RoleBasedRoute
						permissionLevel={[Roles.ADMIN]}
						path="/dashboard/apikeys/new"
						component={ApikeysForm}
					/>
					<RoleBasedRoute
						permissionLevel={[Roles.ADMIN]}
						exact
						path="/dashboard/providers"
						component={() => <ProvidersListing width={width} />}
					/>
					<RoleBasedRoute
						permissionLevel={[Roles.ADMIN]}
						path="/dashboard/providers/:id/edit"
						component={ProvidersForm}
					/>
					<RoleBasedRoute
						permissionLevel={[Roles.ADMIN]}
						path="/dashboard/providers/new"
						component={ProvidersForm}
					/>
					<RoleBasedRoute
						permissionLevel={[Roles.MANAGER, Roles.ADMIN]}
						exact
						path="/dashboard/fails"
						component={() => <FailedAudioListing width={width} />}
					/>

					<RoleBasedRoute
						permissionLevel={[Roles.MANAGER, Roles.ADMIN, Roles.USER]}
						exact
						path="/dashboard/projects"
						component={() => <ProjectsListing width={width} />}
					/>
					<RoleBasedRoute
						permissionLevel={[Roles.MANAGER, Roles.ADMIN, Roles.USER]}
						exact
						path="/dashboard/prompts"
						component={() => <Redirect to="/dashboard/projects" />}
					/>
					<RoleBasedRoute
						permissionLevel={[Roles.MANAGER, Roles.ADMIN, Roles.USER]}
						exact
						path="/dashboard/projects/new"
						component={ProjectsForm}
					/>
					<RoleBasedRoute
						permissionLevel={[Roles.MANAGER, Roles.ADMIN, Roles.USER]}
						path="/dashboard/projects/:id/edit"
						component={ProjectsForm}
					/>

					{/* PROMPTS */}
					<RoleBasedRoute
						permissionLevel={[Roles.MANAGER, Roles.ADMIN, Roles.USER]}
						path="/dashboard/prompts/:id/edit"
						component={PromptsForm}
					/>
					<RoleBasedRoute
						permissionLevel={[Roles.MANAGER, Roles.ADMIN, Roles.USER]}
						exact
						path="/dashboard/projects/:idProject/prompts"
						component={() => <PromptsListing width={width} />}
					/>
					<RoleBasedRoute
						permissionLevel={[Roles.MANAGER, Roles.ADMIN, Roles.USER]}
						exact
						path="/dashboard/projects/:idProject/prompts/:id/edit"
						component={() => <PromptsForm width={width} {...props} />}
					/>
					<RoleBasedRoute
						permissionLevel={[Roles.MANAGER, Roles.ADMIN, Roles.USER]}
						path="/dashboard/projects/:idProject/prompts/new"
						component={PromptsForm}
					/>

					{/* MODELS */}
					<RoleBasedRoute
						permissionLevel={[Roles.MANAGER, Roles.ADMIN]}
						path="/dashboard/models/:id/edit"
						component={() => <VoiceModelsForm />}
					/>
					<RoleBasedRoute
						permissionLevel={[Roles.MANAGER, Roles.ADMIN]}
						path="/dashboard/models/new"
						component={() => <VoiceModelsForm />}
					/>

					<RoleBasedRoute
						permissionLevel={[Roles.MANAGER, Roles.ADMIN]}
						path="/dashboard/models"
						exact
						component={() => <VoiceModelsListing width={width} />}
					/>

					{/* SETTINGS */}
					<RoleBasedRoute
						permissionLevel={[Roles.ADMIN]}
						path="/dashboard/settings"
						component={() => <SettingsManagerForm />}
					/>

					<RoleBasedRoute
						permissionLevel={[Roles.ADMIN]}
						path="/dashboard/maintenance-settings"
						component={() => <MaintenanceSettingsPage />}
					/>

					{/* COSTS */}
					<RoleBasedRoute
						permissionLevel={[Roles.MANAGER, Roles.ADMIN]}
						path="/dashboard/costs"
						component={() => <CostsForm width={width} />}
					/>

					{/* PRESETS */}
					<RoleBasedRoute
						permissionLevel={[Roles.MANAGER, Roles.ADMIN, Roles.MANAGER]}
						exact
						path="/dashboard/presets"
						component={() => <PresetsListing width={width} {...props} />}
					/>
					<RoleBasedRoute
						permissionLevel={[Roles.MANAGER, Roles.ADMIN, Roles.MANAGER]}
						path="/dashboard/presets/new"
						component={PresetsForm}
					/>
					<RoleBasedRoute
						permissionLevel={[Roles.MANAGER, Roles.ADMIN, Roles.MANAGER]}
						path="/dashboard/presets/:id/edit"
						component={PresetsForm}
					/>
				</JssProvider>
			</Switch>
		</Suspense>
	);
}
